<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Comentario</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Comentario</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" [disabled]="form.invalid" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Comentario}}</mat-label>

                        <textarea #comentario matInput maxlength="4000" formControlName="comentarioLogAutorizacion"
                            type="text"></textarea>
                        <mat-hint align="start">Máximo: 4000
                            caracteres</mat-hint>
                        <mat-hint align="end">{{comentario.value?.length
                            || 0}} / 4000</mat-hint>

                        <mat-error
                            *ngIf="required && (form.get('comentarioLogAutorizacion').hasError('required')) && form.get('comentarioLogAutorizacion').touched">
                            {{Validaciones.Comentario}}
                        </mat-error>

                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="aceptar()" [disabled]="form.invalid" mat-flat-button color="accent">Aceptar</button>
</mat-dialog-actions>